import { render, staticRenderFns } from "./AccessAPI.vue?vue&type=template&id=91de4480&scoped=true"
import script from "./AccessAPI.vue?vue&type=script&lang=js"
export * from "./AccessAPI.vue?vue&type=script&lang=js"
import style0 from "./AccessAPI.vue?vue&type=style&index=0&id=91de4480&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91de4480",
  null
  
)

export default component.exports